<script setup>
defineProps({
    expanded: { type: Boolean, required: true },
    id: { type: String, default: undefined },
});
</script>

<template>
    <div
        class="ticket-desk-collapse"
        :class="{ 'ticket-desk-collapse--expanded': expanded }"
        :id="id"
        :aria-hidden="expanded ? undefined : 'true'"
        :inert="expanded ? undefined : true"
    >
        <div class="ticket-desk-collapse__inner">
            <slot />
        </div>
    </div>
</template>
